/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiB (kibibyte) is exactly 1,024 bytes, a binary unit; KB (kilobyte) is exactly 1,000 bytes, a decimal unit, under the modern standard. They're often confused because older software labeled binary values with decimal names — this converter keeps them separate so you can convert accurately either way.`)
};

const es_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiB (kibibyte) es exactamente 1,024 bytes, una unidad binaria; KB (kilobyte) es exactamente 1,000 bytes, una unidad decimal, bajo el estándar moderno. Frecuentemente se confunden porque software más antiguo etiquetaba valores binarios con nombres decimales — este conversor los mantiene separados para que puedas convertir con precisión de cualquier manera.`)
};

const de_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiB (Kibibyte) sind exakt 1,024 Byte, eine binäre Einheit; KB (Kilobyte) sind nach dem modernen Standard exakt 1,000 Byte, eine dezimale Einheit. Sie werden oft verwechselt, weil ältere Software binäre Werte mit dezimalen Namen beschriftete — dieser Umrechner hält sie getrennt, damit Sie in beide Richtungen präzise umrechnen können.`)
};

const nl_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiB (kibibyte) is precies 1.024 bytes, een binaire eenheid; KB (kilobyte) is precies 1.000 bytes, een decimale eenheid, onder de moderne norm. Zij worden vaak verward omdat oudere software binaire waarden met decimale namen labelden — deze convertor houdt hen gescheiden zodat u nauwkeurig elk kan converteren.`)
};

const fr_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiB (kibioctet) est exactement 1 024 octets, une unité binaire ; KB (kilooctet) est exactement 1 000 octets, une unité décimale, sous la norme moderne. Elles sont souvent confondues car le logiciel plus ancien étiquetait les valeurs binaires avec des noms décimaux — ce convertisseur les garde séparés pour que vous puissiez convertir précisément de l'une ou l'autre manière.`)
};

const it_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiB (kibibyte) è esattamente 1.024 byte, un'unità binaria; KB (kilobyte) è esattamente 1.000 byte, un'unità decimale, secondo lo standard moderno. Sono spesso confusi perché il software più vecchio etichettava i valori binari con nomi decimali — questo convertitore li mantiene separati in modo da poter convertire accuratamente in entrambi i modi.`)
};

const pt_br2_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiB (kibibyte) é exatamente 1.024 bytes, uma unidade binária; KB (kilobyte) é exatamente 1.000 bytes, uma unidade decimal, sob o padrão moderno. Eles frequentemente se confundem porque software mais antigo rotulava valores binários com nomes decimais — este conversor os mantém separados para que você possa converter com precisão de qualquer forma.`)
};

const pt_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiB (kibibyte) é exactamente 1024 bytes, uma unidade binária; KB (quilobyte) é exactamente 1000 bytes, uma unidade decimal, sob o padrão moderno. Frequentemente são confundidos porque software mais antigo rotulava valores binários com nomes decimais — este conversor mantém-os separados para que possa converter com precisão de qualquer forma.`)
};

const ja_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiB(キビバイト)は正確に1,024バイト、2進単位です。KB(キロバイト)は正確に1,000バイト、近代標準の下での10進単位です。古いソフトウェアが2進値を10進名でラベルが付けられたため、それらはしばしば混乱されます — このコンバーターはそれらを分けておくため、どちらの方法でも正確に変換できます。`)
};

const zh_uc_data_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_data_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_data_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_data_faq3_a", locale)
	if (locale === "en") return en_uc_data_faq3_a(inputs)
	if (locale === "es") return es_uc_data_faq3_a(inputs)
	if (locale === "de") return de_uc_data_faq3_a(inputs)
	if (locale === "nl") return nl_uc_data_faq3_a(inputs)
	if (locale === "fr") return fr_uc_data_faq3_a(inputs)
	if (locale === "it") return it_uc_data_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_data_faq3_a(inputs)
	if (locale === "pt") return pt_uc_data_faq3_a(inputs)
	if (locale === "ja") return ja_uc_data_faq3_a(inputs)
	return zh_uc_data_faq3_a(inputs)
};